<div class="scrollable-y m-15 p-15" style="padding-bottom:150px">
  <img class="img-banner" src="assets/img/game-plan.png" alt="Client Onboarding Game Plan">

  <h1>Client Onboarding Game Plan</h1>

  <div class="row">
    <div class="col-md-7">
      <p>
        A simple step-by-step approach to help you get your clients onboard and reap the full benefits of Client Hub:
      </p>
      <ol>
        <li>
          <h3>
            Choose a few pilot clients
          </h3>
          <p>
            <strong style="font-style: italic">Tip:</strong> Start with 3 to 5 “good fit” clients when you are starting out with Client Hub. To identify the right clients, consider the following:
          </p>
          <ul type="a" class="spacing">
            <li>Clients who are often in communication with your team (ideally, weekly or more) </li>
            <li>Clients for whom you can introduce new ideas, for example clients who would would likely want to communicate with your team through mobile apps (maybe they already send text messages) </li>
          </ul>
        </li>
        <li>
          <h3>
            Take a Win-Win Framing
          </h3>
          <p>
            <strong style="font-style: italic">Tip:</strong> It is natural to think twice about changing processes and introducing a new app to your clients. The key is to help clients understand why you want to try a new process and explain how it is in your clients’ interest to use Client Hub over crowded and insecure email boxes.
          </p>
          <p>Before you actually invite them into Client Hub, you can prepare your clients for a smooth transition to Client Hub:</p>
          <ul type="a" class="spacing">
            <li>Use the <a href="http://clienthub.reamaze.com/kb/resources-c497cc160eeddd79/client-pre-invite-sample-email-template" target="_blank" rel="noreferrer noopener">sample email templates</a></li>
            <li>Invite your clients to join a presentation (Web or in person). You can use this <a href="http://clienthub.reamaze.com/kb/resources-c497cc160eeddd79/client-introduction-power-point-deck" target="_blank" rel="noreferrer noopener">Powerpoint deck</a> as a template</li>
          </ul>
        </li>

        <li>
          <h3>Invite them into Client Hub </h3>
          <p>Once you’ve identified your pilot clients and you’ve prepared them, then
          </p>
          <ul type="a" class="spacing">
            <li>Add the Client Workspace to Client Hub and Send an invite to the Client User</li>
            <li>Monitor invites: Check the Client Details tab and re-send invites for clients that have not accepted within 2 days. If they do not accept after re-send, contact them to see if their invites have been going to the spam folder. Alternatively, you can copy the invite link and include it in a personal email message.
            </li>
          </ul>
        </li>

        <li>
          <h3>Get quick adoption through Client Tasks and Mobile</h3>
          <p><strong style="font-style: italic">Tip 1:</strong> You can create a “To Do” Client Task to view a Welcome Video you have created (here is a <a href="http://clienthub.reamaze.com/kb/resources-c497cc160eeddd79/client-intro-to-your-workspace-video-and-scrip" target="_blank" rel="noreferrer noopener">sample script</a>). Or, you can create a “To Do” item to download the Client Hub mobile app</p>
          <p><strong style="font-style: italic">Tip 2:</strong> Make sure that your clients download and use the Client Hub mobile app - most clients find it the best way to engage on Client Hub.<br>When you have open client questions or tasks, make sure you use Client Tasks to assign these to clients. This will get your clients back into Client Hub on a regular basis</p>
        </li>

        <li>
          <h3>Provide client on-demand training using Global Resources</h3>
          <p><strong style="font-style: italic">Tip 1:</strong> Add the  “Client Hub How to…” Global resources to the workspace to provide step by step instructions for your clients so they can learn how to navigate and use the features of their new workspace</p>
          <p><strong style="font-style: italic">Tip 2:</strong> You can create a “To Do” Client Task instructing your clients to read the resources </p>
        </li>
       
        <li>
          <h3>Offer a transition period and then enforce the new platform</h3>
          <p><strong style="font-style: italic">Tip:</strong> According to the experts, the speed of new habit pattern development is largely determined by the intensity of the emotion that accompanies the decision to begin acting in a particular way. It takes about 21 days to break or form a habit pattern of medium complexity.</p>
          <ul type="a" class="spacing">
            <li>For clients that communicate with you weekly or more, set a transition period of up to 2 weeks</li>
            <li>For clients that communicate less often, you can stretch to about 30 days. Any longer does not create a sense of urgency to use the new platform
            </li>
          </ul>
          <p>After the transition period, simply reinforce the new behavior by always coming back to the Client Hub platform:</p>
          <ul type="a" class="spacing">
            <li>When Client Sends email or text - Reply to the email via workspace</li>
            <li>When Client calls on phone - post a summary of your call as a client task (Accept / Decline)

            </li>
            <li>In your email client, create a filter for the client’s email address to auto-send a canned response directing them to their workspace (include a link to the CH login page). Let them know that if they have a critical or sensitive matter they can schedule an appointment or call you on the phone.

            </li>
          </ul>
        </li>
       
        <li>
          <h3>Expand across your clients and maximize the benefits</h3>
          <p><strong style="font-style: italic">Tip:</strong> When you have seen the power of Client Hub with your first few clients, you will want to expand it to all your clients, so that they all get the benefits of working with your team in a simple, secure way -- and that makes your team more productive in serving them</p>
          <ul type="a" class="spacing">
            <li>If you have a larger firm and haven’t introduced Client Hub to other staff, you can do that internally or have us help you -- just reach out and request a complementary demo and discussion that we will lead with your team </li>
            <li>When you are inviting additional clients, feel free to use the same templates as you did for your pilot clients, but also enhance the message with the fact that your clients have seen success with Client Hub already
            </li>
          </ul>
        </li>

      </ol>

      <div style="padding-left: 40px; font-size: 1.15rem; margin-top: 20px;">
        <strong>Still have questions on Client Onboarding?</strong><br>
      <strong><a href="https://calendly.com/judiech/client-hub-ask-the-expert-video-call" target="_blank" rel="noreferrer noopener" rel="noopener noreferrer">Click here</a> to schedule an "Ask the Expert" video conference </strong>
      </div>
    </div>

    <div class="col-md-5">
      <div class="faq">
        <h3 style="margin-top: 0">Resources</h3>
        <h4>To introduce Client Hub</h4>
        <ul>
          <li><a
              href="https://clienthub.reamaze.com/kb/resources-c497cc160eeddd79/client-pre-invite-sample-email-template"
              target="_blank" rel="noreferrer noopener">Sample email invites</a></li>
          <li><a
              href="https://clienthub.reamaze.com/kb/resources-c497cc160eeddd79/client-intro-to-your-workspace-video-and-scrip"
              target="_blank" rel="noreferrer noopener">Welcome video script</a></li>
        </ul>
        <h4>To train your clients on Client Hub</h4>
        <ul>
          <li><a href="https://docs.google.com/document/d/1xNAN1O7qko9WWvkX3F4AcFrFKGPCAINATwkh4P7SpgA/"
              target="_blank" rel="noreferrer noopener">“Welcome to Your Client Hub Workspace” Guide</a></li>
          <li><a href="https://docs.google.com/presentation/d/1v9TTpGVzoPa0LkW_2I5pXL9T3cuD8BOz804bCy_28S0/"
              target="_blank" rel="noreferrer noopener">Presentation Slide Deck</a></li>
        </ul>
        <h4>To re-inforce use of Client Hub</h4>
        <ul>
          <li><a href="https://clienthub.reamaze.com/articles/client-sample-email-signature-or-auto-responder"
              target="_blank" rel="noreferrer noopener">Email signature and/or auto-responder</a></li>
          <li>Make Client Hub your clients’ start page:<br>
            <a href="" target="_blank" rel="noreferrer noopener">Chrome</a> /
            <a href="" target="_blank" rel="noreferrer noopener">Firefox</a> /
            <a href="" target="_blank" rel="noreferrer noopener">Safari</a>
          </li>
        </ul>
      </div>
    </div>
  </div>

</div>